import Vue from 'vue';
import Vuex from 'vuex';
import SearchBar from '../module/SearchBar/view/vue/SearchBar.vue';
import Tweakwise from '../module/Deals/view/vue/Tweakwise.vue';
import SearchAndFilter from "../module/Deals/view/vue/SearchAndFilter.vue";
import Loader from './components/Loader.vue';
import dayjs from "./plugins/dayjs";
import 'url-polyfill';
import 'url-search-params-polyfill';

import DealsAvailabilityWrapper from "../module/Availability/view/vue/components/DealsAvailabilityWrapper.vue";
import HotelsAvailabilityWrapper from "../module/Availability/view/vue/components/HotelsAvailabilityWrapper.vue";

import SearchBarCalendar from "../module/SearchBar/view/vue/SearchBarCalendar.vue";
import InboxBadge from "../module/Account/view/vue/components/InboxBadge.vue";
import SortList from "./components/filter/SortListFilter.vue";
import FilterModal from "./components/filter/FilterModal.vue";
import BottomDrawer from "./components/BottomDrawer.vue";
import FavoriteService from "./services/FavoriteService";
import restaurantsSearchBanner from './store/modules/restaurantsSearchBanner';
import hotelsSearchBanner from './store/modules/hotelsSearchBanner';

Vue.use( dayjs );
Vue.use( Vuex );

Vue.config.devtools = false;

/** The favourite uniques are fetched once per page, by the first deal card or search that needs them */
let favoriteUniquesRequest: Promise<void> | null = null;
/** Counts the requests, so an older one that settles late cannot overwrite or clear a newer one */
let favoriteUniquesRequestNumber = 0;

const store = new Vuex.Store( {
    state     : {
        favoriteUniques : [] as Array<string>,
    },
    getters   : {
        favoriteUniques( state ): Array<string> {
            return state.favoriteUniques;
        }

    },
    mutations : {
        setFavoriteUniques( state, payload: Array<string> ): void {
            state.favoriteUniques = payload;
        },
        removeFavorite( state, payload: string ): void {
            const index = state.favoriteUniques.findIndex( unique => unique === payload );
            if ( index !== -1 ) {
                state.favoriteUniques.splice( index, 1 );
            }
        },
        addFavorite( state, payload: string ): void {
            state.favoriteUniques.push( payload );
        }
    },
    actions   : {
        /** force fetches them again, e.g. when the search opens, as hearts outside Vue can change them */
        loadFavoriteUniques( { commit }, force: boolean = false ): Promise<void> {
            if ( favoriteUniquesRequest === null || force ) {
                const requestNumber = ++favoriteUniquesRequestNumber;
                favoriteUniquesRequest = FavoriteService.getFavoriteCampaignUniques()
                    .then( ( uniques: Array<string> ) => {
                        if ( requestNumber === favoriteUniquesRequestNumber ) {
                            commit( 'setFavoriteUniques', uniques );
                        }
                    } )
                    .catch( () => {
                        if ( requestNumber === favoriteUniquesRequestNumber ) {
                            favoriteUniquesRequest = null;
                        }
                    } );
            }

            return favoriteUniquesRequest;
        }
    },
    modules: {
        restaurantsSearchBanner: restaurantsSearchBanner,
        hotelsSearchBanner: hotelsSearchBanner,
    }
} );
Vue.prototype.$t = ( key: string ) => {
    return ( window as any
    ).lang[ key ] as Function
}

const vueSections = [
    '#vue-root',
    '#tweakwise-root',
    '#tweakwise-root-details',
    '#availability-box',
    '#navbar',
    '.mobile-footer'
];

for ( var i = 0; i < vueSections.length; i ++ ) {
    let exists = null;
    if( vueSections[i].charAt(0) === '#' ){
        exists = document.getElementById(vueSections[i].substring(1));
    } else {
        const htmlCollection = document.getElementsByClassName(vueSections[i].substring(1));
        exists = htmlCollection.length > 0 ? htmlCollection : null;
    }

    if(!exists) {
        continue;
    }
    new Vue( {
        el         : vueSections[i],
        store      : store,
        components : {
            Tweakwise,
            DealsAvailabilityWrapper,
            HotelsAvailabilityWrapper,
            SearchBar,
            SearchBarCalendar,
            InboxBadge,
            Loader,
            FilterModal,
            SearchAndFilter
        }
    } );
}




